// Backend URL, picked automatically by Create React App:
//   npm start      → .env.development  (http://localhost:3009)
//   npm run build  → .env.production   (https://ceynexlk.com:3009)
// No more switching this file by hand before a build.
const BackEndUrl = {
  domain: process.env.REACT_APP_API_URL || "https://ceynexlk.com:3009",
};

export default BackEndUrl;
